import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _defineProperty from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

var _AudioOutputFormatImp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { SpeechSynthesisOutputFormat } from "../SpeechSynthesisOutputFormat";
import { AudioStreamFormatImpl } from "./AudioStreamFormat";
export var AudioFormatTag;

(function (AudioFormatTag) {
  AudioFormatTag[AudioFormatTag["PCM"] = 1] = "PCM";
  AudioFormatTag[AudioFormatTag["MuLaw"] = 2] = "MuLaw";
  AudioFormatTag[AudioFormatTag["Siren"] = 3] = "Siren";
  AudioFormatTag[AudioFormatTag["MP3"] = 4] = "MP3";
  AudioFormatTag[AudioFormatTag["SILKSkype"] = 5] = "SILKSkype";
})(AudioFormatTag || (AudioFormatTag = {}));
/**
 * @private
 * @class AudioOutputFormatImpl
 * Added in version 1.11.0
 */
// tslint:disable-next-line:max-classes-per-file


export var AudioOutputFormatImpl = /*#__PURE__*/function (_AudioStreamFormatImp) {
  _inherits(AudioOutputFormatImpl, _AudioStreamFormatImp);

  var _super = _createSuper(AudioOutputFormatImpl);

  /**
   * Creates an instance with the given values.
   * @constructor
   * @param formatTag
   * @param {number} samplesPerSec - Samples per second.
   * @param {number} bitsPerSample - Bits per sample.
   * @param {number} channels - Number of channels.
   * @param avgBytesPerSec
   * @param blockAlign
   * @param audioFormatString
   * @param requestAudioFormatString
   * @param hasHeader
   */
  function AudioOutputFormatImpl(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample, audioFormatString, requestAudioFormatString, hasHeader) {
    var _this;

    _classCallCheck(this, AudioOutputFormatImpl);

    _this = _super.call(this, samplesPerSec, bitsPerSample, channels);
    _this.formatTag = formatTag;
    _this.avgBytesPerSec = avgBytesPerSec;
    _this.blockAlign = blockAlign;
    _this.priAudioFormatString = audioFormatString;
    _this.priRequestAudioFormatString = requestAudioFormatString;
    _this.priHasHeader = hasHeader;
    return _this;
  }

  _createClass(AudioOutputFormatImpl, [{
    key: "updateHeader",

    /**
     * Updates the header based on the audio length
     * @member AudioOutputFormatImpl.updateHeader
     * @function
     * @public
     * @param {number} audioLength - the audio length
     */
    value: function updateHeader(audioLength) {
      if (this.priHasHeader) {
        var view = new DataView(this.privHeader);
        view.setUint32(40, audioLength, true);
      }
    }
    /**
     * Specifies the audio format string to be sent to the service
     * @string AudioOutputFormatImpl.prototype.requestAudioFormatString
     * @function
     * @public
     */

  }, {
    key: "hasHeader",

    /**
     * Specifies if this audio output format has a header
     * @boolean AudioOutputFormatImpl.prototype.hasHeader
     * @function
     * @public
     */
    get: function get() {
      return this.priHasHeader;
    }
    /**
     * Specifies the header of this format
     * @ArrayBuffer AudioOutputFormatImpl.prototype.header
     * @function
     * @public
     */

  }, {
    key: "header",
    get: function get() {
      if (this.hasHeader) {
        return this.privHeader;
      }

      return undefined;
    }
  }, {
    key: "requestAudioFormatString",
    get: function get() {
      return this.priRequestAudioFormatString;
    }
  }], [{
    key: "fromSpeechSynthesisOutputFormat",
    value: function fromSpeechSynthesisOutputFormat(speechSynthesisOutputFormat) {
      return AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString(AudioOutputFormatImpl.SpeechSynthesisOutputFormatToString[speechSynthesisOutputFormat]);
    }
  }, {
    key: "fromSpeechSynthesisOutputFormatString",
    value: function fromSpeechSynthesisOutputFormatString(speechSynthesisOutputFormatString) {
      switch (speechSynthesisOutputFormatString) {
        case "raw-8khz-8bit-mono-mulaw":
          return new AudioOutputFormatImpl(AudioFormatTag.PCM, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);

        case "riff-16khz-16kbps-mono-siren":
          return new AudioOutputFormatImpl(AudioFormatTag.Siren, 1, 16000, 2000, 40, 0, speechSynthesisOutputFormatString, "audio-16khz-16kbps-mono-siren", true);

        case "audio-16khz-16kbps-mono-siren":
          return new AudioOutputFormatImpl(AudioFormatTag.Siren, 1, 16000, 2000, 40, 0, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);

        case "audio-16khz-32kbitrate-mono-mp3":
          return new AudioOutputFormatImpl(AudioFormatTag.MP3, 1, 16000, 32 << 7, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);

        case "audio-16khz-128kbitrate-mono-mp3":
          return new AudioOutputFormatImpl(AudioFormatTag.MP3, 1, 16000, 128 << 7, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);

        case "audio-16khz-64kbitrate-mono-mp3":
          return new AudioOutputFormatImpl(AudioFormatTag.MP3, 1, 16000, 64 << 7, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);

        case "audio-24khz-48kbitrate-mono-mp3":
          return new AudioOutputFormatImpl(AudioFormatTag.MP3, 1, 16000, 48 << 7, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);

        case "audio-24khz-96kbitrate-mono-mp3":
          return new AudioOutputFormatImpl(AudioFormatTag.MP3, 1, 16000, 96 << 7, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);

        case "audio-24khz-160kbitrate-mono-mp3":
          return new AudioOutputFormatImpl(AudioFormatTag.MP3, 1, 16000, 160 << 7, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);

        case "raw-16khz-16bit-mono-truesilk":
          return new AudioOutputFormatImpl(AudioFormatTag.SILKSkype, 1, 16000, 32000, 2, 16, speechSynthesisOutputFormatString, speechSynthesisOutputFormatString, false);

        case "riff-8khz-16bit-mono-pcm":
          return new AudioOutputFormatImpl(AudioFormatTag.PCM, 1, 8000, 16000, 2, 16, speechSynthesisOutputFormatString, "raw-8khz-16bit-mono-pcm", true);

        case "riff-24khz-16bit-mono-pcm":
          return new AudioOutputFormatImpl(AudioFormatTag.PCM, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, "raw-24khz-16bit-mono-pcm", true);

        case "riff-8khz-8bit-mono-mulaw":
          return new AudioOutputFormatImpl(AudioFormatTag.MuLaw, 1, 8000, 8000, 1, 8, speechSynthesisOutputFormatString, "raw-8khz-8bit-mono-mulaw", true);

        case "raw-16khz-16bit-mono-pcm":
          return new AudioOutputFormatImpl(AudioFormatTag.PCM, 1, 16000, 32000, 2, 16, speechSynthesisOutputFormatString, "raw-16khz-16bit-mono-pcm", false);

        case "raw-24khz-16bit-mono-pcm":
          return new AudioOutputFormatImpl(AudioFormatTag.PCM, 1, 24000, 48000, 2, 16, speechSynthesisOutputFormatString, "raw-24khz-16bit-mono-pcm", false);

        case "raw-8khz-16bit-mono-pcm":
          return new AudioOutputFormatImpl(AudioFormatTag.PCM, 1, 8000, 16000, 2, 16, speechSynthesisOutputFormatString, "raw-8khz-16bit-mono-pcm", false);

        case "riff-16khz-16bit-mono-pcm":
        default:
          return new AudioOutputFormatImpl(AudioFormatTag.PCM, 1, 16000, 32000, 2, 16, "riff-16khz-16bit-mono-pcm", "raw-16khz-16bit-mono-pcm", true);
      }
    }
  }, {
    key: "getDefaultOutputFormat",
    value: function getDefaultOutputFormat() {
      return AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString("");
    }
  }]);

  return AudioOutputFormatImpl;
}(AudioStreamFormatImpl);
AudioOutputFormatImpl.SpeechSynthesisOutputFormatToString = (_AudioOutputFormatImp = {}, _defineProperty(_AudioOutputFormatImp, SpeechSynthesisOutputFormat.Raw8Khz8BitMonoMULaw, "raw-8khz-8bit-mono-mulaw"), _defineProperty(_AudioOutputFormatImp, SpeechSynthesisOutputFormat.Riff16Khz16KbpsMonoSiren, "riff-16khz-16kbps-mono-siren"), _defineProperty(_AudioOutputFormatImp, SpeechSynthesisOutputFormat.Audio16Khz16KbpsMonoSiren, "audio-16khz-16kbps-mono-siren"), _defineProperty(_AudioOutputFormatImp, SpeechSynthesisOutputFormat.Audio16Khz32KBitRateMonoMp3, "audio-16khz-32kbitrate-mono-mp3"), _defineProperty(_AudioOutputFormatImp, SpeechSynthesisOutputFormat.Audio16Khz128KBitRateMonoMp3, "audio-16khz-128kbitrate-mono-mp3"), _defineProperty(_AudioOutputFormatImp, SpeechSynthesisOutputFormat.Audio16Khz64KBitRateMonoMp3, "audio-16khz-64kbitrate-mono-mp3"), _defineProperty(_AudioOutputFormatImp, SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3, "audio-24khz-48kbitrate-mono-mp3"), _defineProperty(_AudioOutputFormatImp, SpeechSynthesisOutputFormat.Audio24Khz96KBitRateMonoMp3, "audio-24khz-96kbitrate-mono-mp3"), _defineProperty(_AudioOutputFormatImp, SpeechSynthesisOutputFormat.Audio24Khz160KBitRateMonoMp3, "audio-24khz-160kbitrate-mono-mp3"), _defineProperty(_AudioOutputFormatImp, SpeechSynthesisOutputFormat.Raw16Khz16BitMonoTrueSilk, "raw-16khz-16bit-mono-truesilk"), _defineProperty(_AudioOutputFormatImp, SpeechSynthesisOutputFormat.Riff16Khz16BitMonoPcm, "riff-16khz-16bit-mono-pcm"), _defineProperty(_AudioOutputFormatImp, SpeechSynthesisOutputFormat.Riff8Khz16BitMonoPcm, "riff-8khz-16bit-mono-pcm"), _defineProperty(_AudioOutputFormatImp, SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm, "riff-24khz-16bit-mono-pcm"), _defineProperty(_AudioOutputFormatImp, SpeechSynthesisOutputFormat.Riff8Khz8BitMonoMULaw, "riff-8khz-8bit-mono-mulaw"), _defineProperty(_AudioOutputFormatImp, SpeechSynthesisOutputFormat.Raw16Khz16BitMonoPcm, "raw-16khz-16bit-mono-pcm"), _defineProperty(_AudioOutputFormatImp, SpeechSynthesisOutputFormat.Raw24Khz16BitMonoPcm, "raw-24khz-16bit-mono-pcm"), _defineProperty(_AudioOutputFormatImp, SpeechSynthesisOutputFormat.Raw8Khz16BitMonoPcm, "raw-8khz-16bit-mono-pcm"), _AudioOutputFormatImp);